import { render, staticRenderFns } from "./PanelBest.vue?vue&type=template&id=75499794&scoped=true"
import script from "./PanelBest.vue?vue&type=script&lang=js"
export * from "./PanelBest.vue?vue&type=script&lang=js"
import style0 from "./PanelBest.vue?vue&type=style&index=0&id=75499794&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75499794",
  null
  
)

export default component.exports